import React from "react";
import ReactSelect from "react-select";
import gql from "graphql-tag";
import { withQuery } from "containers/withQuery";

const FORMULAS_QUERY = gql`
query {
  concreteFormulas(active: true) {
    id
    code
    fck
    concreteFamily {
      slump {
        id
        description
      }
    }
  }
}
`;

const DEFAULT_WIDTH = 300;
const DEFAULT_PADDING = 0;

const Select = ({
  value,
  onChange,
  concreteFormulas,
  width = DEFAULT_WIDTH,
  padding = DEFAULT_PADDING,
}) => (
  <div style={{ width, fontWeight: "bold", padding }}>
    <ReactSelect
      className="react-select dark"
      classNamePrefix="react-select"
      name="itemSelected"
      value={value}
      onChange={onChange}
      options={[
        {
          value: "",
          isDisabled: true
        },
        ...concreteFormulas.map(({
          id,
          code,
          fck,
          concreteFamily: {
            slump: {
              description,
            }
          }
        }) => ({
          value: id,
          code,
          label: `Cód. ${code} | FCK ${fck} | Slump ${description}`,
        }))
      ]}
      placeholder="Escolha..."
    />
  </div>
);

export default withQuery({
  query: FORMULAS_QUERY
})(Select);
